import React, { ReactNode } from 'react';

import KebabOptions from '../../kebab-options/KebabOptions';

import './KebabCellRenderer.scss';
import { UseMasterDataAccess } from 'modules/master-data/role-access-hooks/useMasterDataAccess';
import {
    CategoryFeatureAccess,
    IndicatorFeatureAccess,
    MasterDataFeatureAccess,
    SubCategoryFeatureAccess
} from 'modules/master-data/models/master-data-role-access.model';

type KebabCellRendererProps = {
    data: any;
    isUploadDisabled: boolean;
    uploadedUser: string;
    isSyncInProgress: boolean;
    onAction: (action: string, data: any) => void;
    masterDataFeatureActionList?: UseMasterDataAccess;
};

const defaultMasterDataAccess: MasterDataFeatureAccess = {
    isMappingToGBBPublicDisabled: false,
    isMasterDataArchiveDisabled: false,
    isRestoreArchivedMasterDataDisabled: false,
    isDeleteArchivedMasterDataDisabled: false,
    isExportMasterDataDisabled: false
};
const defaultCategoryAccess: CategoryFeatureAccess = {
    isAddNewCategoryDisabled: false,
    isEditDisabled: false,
    isDeleteDisabled: false,
    isArchiveDisabled: false,
    isCloneDisabled: false,
    isAddNewSubCategoryDisabled: false,
    isExportCategoryDisabled: false
};
const defaultSubCategoryAccess: SubCategoryFeatureAccess = {
    isAddNewSubCategoryDisabled: false,
    isEditDisabled: false,
    isDeleteDisabled: false,
    isArchiveDisabled: false,
    isCloneDisabled: false,
    isMoveDisabled: false,
    isAddNewIndicatorDisabled: false,
    isExportSubCategoryDisabled: false
};
const defaultIndicatorAccess: IndicatorFeatureAccess = {
    isEditDisabled: false,
    isDeleteDisabled: false,
    isArchiveDisabled: false,
    isCopyDisabled: false,
    isMoveDisabled: false,
    isLinkDisabled: false,
    isExportIndicatorDisabled: false
};
const defaultMasterDataFeatureAccessList: UseMasterDataAccess = {
    masterDataFeatureAccess: defaultMasterDataAccess,
    categoryFeatureAccess: defaultCategoryAccess,
    subCategoryFeatureAccess: defaultSubCategoryAccess,
    indicatorFeatureAccess: defaultIndicatorAccess
};
export default function KebabCellRenderer({
    data,
    isUploadDisabled,
    uploadedUser,
    isSyncInProgress,
    masterDataFeatureActionList = defaultMasterDataFeatureAccessList,
    onAction
}: KebabCellRendererProps) {
    return (
        <KebabOptions
            data={data}
            isUploadDisabled={isUploadDisabled}
            uploadedUser={uploadedUser}
            onAction={onAction}
            isSyncInProgress={isSyncInProgress}
            masterDataFeatureActionList={masterDataFeatureActionList}
        />
    );
}
